import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Chip,
  Button,
  Grid,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  InputAdornment,
  IconButton,
  Tab,
  Tabs,
  useMediaQuery,
  Stack,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  FormHelperText,
  MenuItem,
} from "@mui/material";
import { Table as CustomTable } from "app/components";
import { Icon } from "@iconify/react";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import { useDispatch, useSelector } from "react-redux";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import {
  getMeeshoReturnById,
  getMeeshoReturnList,
  importMeeshoOrdersReturn,
  importMeeshoReturnRTOAction,
  meeshoOrderReturnClaimStatus,
} from "app/redux/slice/meeshoSlice";
import { usePagination } from "app/hooks/usePagination";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { MEESHO } from "app/routes/constant";
import Loader from "@jumbo/components/Loader";
import { LoadingButton } from "@mui/lab";
import JumboAppTextField from "@jumbo/components/JumboAppTextField";

const MeeshoRTO = () => {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const meeshoData = useSelector((state) => state?.meesho);
  const [importLoading, setImportLoading] = useState(false);

  const [openDialog, setOpenDialog] = useState(false);
  const [openClaimDialog, setOpenClaimDialog] = useState(false);
  const [selectedRTO, setSelectedRTO] = useState(null);
  const [orderId, setOrderId] = useState("");
  const [showRTOPopup, setShowRTOPopup] = useState(false);
  const [foundOrder, setFoundOrder] = useState(null);
  const [showOrdersList] = useState(true);
  const [tabValue, setTabValue] = useState(0);
  const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage } =
    usePagination({ id: "meesho-orders-return" });
  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("createdAt");
  const mobileView = useMediaQuery("(max-width:575px)");
  const validationSchema = Yup.object({
    claimStatus: Yup.string().required("Please select a Claim Status"),
    claimApproval: Yup.string().required("Please select a Claim Approval"),
    claimNote: Yup.string().when("claimApproval", {
      is: (val) => val === "rejected",
      then: (schema) => schema.required("Please enter Claim Note"),
      otherwise: (schema) => schema.notRequired(),
    }),
  });

  // const rtoReasons = [
  //   { reason: "Return Requested", count: 2, percentage: 100 },
  // ];

  const getStatusColor = (status) => {
    switch (status) {
      case "Product Not Received":
        return "error";
      case "Claim Submitted":
        return "warning";
      case "Claim Approved":
        return "success";
      case "Payment Received":
        return "success";
      case "RTO Received":
        return "success";
      case "Wrong RTO":
        return "error";
      case "Pending":
        return "warning";
      default:
        return "default";
    }
  };

  const getStatusColorClaim = (status) => {
    switch (status) {
      case "required":
        return "error";
      case "pending":
        return "warning";
      case "applied":
        return "success";
      case "approved":
        return "success";
      case "rejected":
        return "error";
      default:
        return "default";
    }
  };

  const sortData = (Order, OrderBy) => {
    setOrder(Order);
    setOrderBy(OrderBy);
  };
  const handleViewDetails = (rto) => {
    setSelectedRTO(rto);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedRTO(null);
  };

  // Search for order by ID
  const handleSearchOrder = (searchOrderId = orderId) => {
    if (!searchOrderId.trim()) {
      alert("Please enter an Order ID");
      return;
    }

    if (searchOrderId) {
      dispatch(getMeeshoReturnById({ subOrderNumber: searchOrderId }))
        .unwrap()
        .then((response) => {
          if (response.status === 200) {
            if (response?.data?.data?.orderDetail?.orderState === "complete") {
              enqueueSnackbar("Order already completed", {
                variant: "error",
              });
            } else {
              if (!response?.data?.data?.orderDetail) {
                enqueueSnackbar("Data not found", {
                  variant: "error",
                });
              } else {
                setFoundOrder(response?.data?.data?.orderDetail);
                setShowRTOPopup(true);
              }
            }
          } else {
            enqueueSnackbar(response.data?.responseMessage, {
              variant: "error",
            });
          }
        });
    }
    setOrderId("");
  };

  // Handle RTO status update
  const handleRTOReceived = (data) => {
    if (foundOrder) {
      dispatch(
        importMeeshoReturnRTOAction({
          subOrderNumber: foundOrder.subOrderNumber,
          isOriginalProduct: data,
        })
      )
        .unwrap()
        .then((response) => {
          if (response.status === 200) {
            enqueueSnackbar(response.data?.responseMessage, {
              variant: "success",
            });
          } else {
            enqueueSnackbar(response.data?.responseMessage, {
              variant: "error",
            });
          }
        });
      setShowRTOPopup(false);
      setFoundOrder(null);
      setOrderId("");
    }
  };

  // Load orders data
  const getOrdersData = () => {
    const value = {
      page: page,
      perPage: rowsPerPage,
      // search: searchTerm.trim(),
      // status: statusFilter !== "all" ? statusFilter : undefined,
    };
    if (orderBy !== "") {
      value.sort = order === "asc" ? 1 : -1;
      value.field = orderBy;
    }
    if (tabValue === 3) {
      value.forClaim = 1;
    }
    dispatch(getMeeshoReturnList(value));
  };

  useEffect(() => {
    if (tabValue === 1 || tabValue === 3) getOrdersData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, rowsPerPage, dispatch, order, orderBy, tabValue]);

  useEffect(() => {
    getOrdersData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCloseRTOPopup = () => {
    setShowRTOPopup(false);
    setFoundOrder(null);
  };
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };
  const handleFileSelect = (event, type) => {
    const file = event.target.files[0];
    if (file) {
      handleImportFile(file, type);
    }
  };

  const handleViewClaimDetails = (rto) => {
    setSelectedRTO(rto);
    setOpenClaimDialog(true);
  };
  const handleCloseClaimDialog = () => {
    setOpenClaimDialog(false);
    setSelectedRTO(null);
  };

  const columns = [
    {
      id: "subOrderNumber",
      label: "Sub Order No",
      sort: true,
      render: (row) => (
        <Typography
          variant="body2"
          sx={{ fontWeight: "bold", color: "#2874f0" }}
        >
          {row.subOrderNumber}
        </Typography>
      ),
    },
    {
      id: "orderNumber",
      label: "Order No",
      sort: true,
      render: (row) => (
        <Typography
          variant="body2"
          sx={{ fontWeight: "bold", color: "#2874f0" }}
        >
          {row.orderNumber}
        </Typography>
      ),
    },
    {
      id: "sku",
      label: "SKU",
      sort: true,
      render: (row) => (
        <Typography variant="caption" sx={{ fontFamily: "monospace" }}>
          {row.sku}
        </Typography>
      ),
    },
    {
      id: "qty",
      label: "Qty",
      sort: true,
      align: "center",
    },
    {
      id: "status",
      label: "Status",
      sort: true,
      render: (row) => (
        <Chip
          label={row.status}
          color={getStatusColor(row.status)}
          size="small"
        />
      ),
    },
    {
      id: "returnCreatedDate",
      label: "Return Order Date",
      sort: true,
      render: (row) => new Date(row.returnCreatedDate).toLocaleDateString(),
    },
    {
      id: "typeOfReturn",
      label: "Type",
      sort: true,
      render: (row) => row.typeOfReturn,
    },
    {
      id: "returnReason",
      label: "Reason",
      sort: true,
      render: (row) => row.returnReason,
    },
    {
      id: "actions",
      label: "Actions",
      align: "right",
      render: (row) => (
        <IconButton onClick={() => handleViewDetails(row)} size="small">
          <VisibilityIcon />
        </IconButton>
      ),
    },
  ];
  const claimColumns = [
    {
      id: "subOrderNumber",
      label: "Sub Order No",
      sort: true,
      render: (row) => (
        <Typography
          variant="body2"
          sx={{ fontWeight: "bold", color: "#2874f0" }}
        >
          {row.subOrderNumber}
        </Typography>
      ),
    },
    {
      id: "orderNumber",
      label: "Order No",
      sort: true,
      render: (row) => (
        <Typography
          variant="body2"
          sx={{ fontWeight: "bold", color: "#2874f0" }}
        >
          {row.orderNumber}
        </Typography>
      ),
    },
    {
      id: "sku",
      label: "SKU",
      sort: true,
      render: (row) => (
        <Typography variant="caption" sx={{ fontFamily: "monospace" }}>
          {row.sku}
        </Typography>
      ),
    },
    {
      id: "claimStatus",
      label: "Claim",
      sort: true,
      render: (row) => (
        <Chip
          label={row.claimStatus}
          color={getStatusColorClaim(row.claimStatus)}
          size="small"
          onClick={() => handleViewClaimDetails(row)}
        />
      ),
    },
    {
      id: "claimApproval",
      label: "Claim Approved",
      sort: true,
      render: (row) => (
        <Chip
          label={row.claimApproval}
          color={getStatusColorClaim(row.claimApproval)}
          size="small"
          onClick={() => handleViewClaimDetails(row)}
        />
      ),
    },
    {
      id: "claimPaymentStatus",
      label: "Payment Status",
      sort: true,
      render: (row) => (
        <Chip
          label={row.claimPaymentStatus}
          color={getStatusColorClaim(row.claimPaymentStatus)}
          size="small"
        />
      ),
    },
    {
      id: "claimAmount",
      label: "Claim Amount",
      sort: true,
      align: "center",
    },
    {
      id: "actions",
      label: "Actions",
      align: "right",
      render: (row) => (
        <IconButton onClick={() => handleViewDetails(row)} size="small">
          <VisibilityIcon />
        </IconButton>
      ),
    },
  ];
  const handleImportFile = async (file, type) => {
    if (!file) {
      enqueueSnackbar("Please select a file to upload", { variant: "error" });
      return;
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("type", type);
    setImportLoading(true);

    try {
      const response = await dispatch(
        importMeeshoOrdersReturn(formData)
      ).unwrap();
      if (response.status === 200) {
        enqueueSnackbar(response.data?.responseMessage || "Import successful", {
          variant: "success",
        });
        // Refresh import history
        // getImportHistoryData();
        setTabValue(1); // Switch to history tab
      } else {
        enqueueSnackbar(response.data?.responseMessage || "Import failed", {
          variant: "error",
        });
      }
    } catch (error) {
      enqueueSnackbar("Import failed. Please try again.", {
        variant: "error",
      });
    } finally {
      setImportLoading(false);
    }
  };

  const handleImportOrders = () => {
    document.getElementById("orders-file-input").click();
  };
  return (
    <Box>
      <input
        id="orders-file-input"
        type="file"
        accept=".csv,.xlsx,.xls"
        style={{ display: "none" }}
        onChange={(e) => {
          handleFileSelect(e, "orders");
          e.target.value = "";
        }}
      />
      {(meeshoData?.importLoading || importLoading) && <Loader />}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "12px",
        }}
      >
        <Typography variant="h3" sx={{ fontWeight: "bold" }}>
          Meesho RTO Management
        </Typography>
        <Button
          variant="contained"
          size="small"
          sx={{ width: "100px" }}
          startIcon={<Icon icon="ep:back" width="24" height="24" />}
          onClick={() => navigate(MEESHO)}
        >
          Back
        </Button>
      </div>

      {/* RTO Statistics */}
      <Grid container spacing={3} sx={{ mb: 3, justifyContent: "center" }}>
        <Grid item xs={12} sm={6} md={2}>
          <Card
            sx={{
              textAlign: "center",
              background: "linear-gradient(135deg, #FF6B3515, #FF6B3505)",
            }}
          >
            <CardContent>
              <Typography
                variant="h4"
                sx={{ fontWeight: "bold", color: "#FF6B35" }}
              >
                {meeshoData?.return?.dashboard?.totalReturns ?? 0}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Total RTOs
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={2}>
          <Card
            sx={{
              textAlign: "center",
              background: "linear-gradient(135deg, #F7931E15, #F7931E05)",
            }}
          >
            <CardContent>
              <Typography
                variant="h4"
                sx={{ fontWeight: "bold", color: "#F7931E" }}
              >
                {meeshoData?.return?.dashboard?.pendingClaim ?? 0}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Claims Pending
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={2}>
          <Card
            sx={{
              textAlign: "center",
              background: "linear-gradient(135deg, #06FFA515, #06FFA505)",
            }}
          >
            <CardContent>
              <Typography
                variant="h4"
                sx={{ fontWeight: "bold", color: "#06FFA5" }}
              >
                {meeshoData?.return?.dashboard?.approvedClaim ?? 0}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Claims Approved
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={2}>
          <Card
            sx={{
              textAlign: "center",
              background: "linear-gradient(135deg, #073B4C15, #073B4C05)",
            }}
          >
            <CardContent>
              <Typography
                variant="h4"
                sx={{ fontWeight: "bold", color: "#073B4C" }}
              >
                {meeshoData?.return?.dashboard?.rejectedClaim ?? 0}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Claims Rejected
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs value={tabValue} onChange={handleTabChange}>
          <Tab label="Import" iconPosition="start" />
          <Tab label="RTO Orders List" iconPosition="start" />{" "}
          <Tab label="RTO Processing" iconPosition="start" />
          <Tab label="Claims - Products Not Received" iconPosition="start" />
        </Tabs>
      </Box>

      <CardContent>
        {tabValue === 0 && (
          <Box>
            <Card sx={{ mb: 3 }}>
              <CardContent>
                <Grid container spacing={3} sx={{ justifyContent: "center" }}>
                  <Grid item xs={12} md={6}>
                    <Card
                      sx={{
                        cursor: "pointer",
                        transition: "all 0.3s ease",
                        "&:hover": {
                          transform: "translateY(-2px)",
                          boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
                        },
                        border: "2px solid #2196f320",
                        borderRadius: 2,
                      }}
                      onClick={handleImportOrders}
                    >
                      <CardContent sx={{ textAlign: "center", p: 3 }}>
                        <Icon
                          icon="material-symbols:shopping-cart"
                          style={{
                            fontSize: "48px",
                            color: "#2196f3",
                            marginBottom: "16px",
                          }}
                        />
                        <Typography
                          variant="h6"
                          sx={{ fontWeight: "bold", mb: 1, color: "#2196f3" }}
                        >
                          Import File
                        </Typography>
                        <Typography
                          variant="body2"
                          color="text.secondary"
                          sx={{ mb: 2 }}
                        >
                          Upload and process data
                        </Typography>
                        <Button
                          variant="contained"
                          sx={{ backgroundColor: "#2196f3" }}
                          startIcon={<Icon icon="material-symbols:upload" />}
                        >
                          Choose File
                        </Button>
                      </CardContent>
                    </Card>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Box>
        )}

        {tabValue === 1 && (
          <Box>
            {/* RTO Orders List - Conditionally Rendered */}
            {showOrdersList && (
              <Grid container spacing={3}>
                {/* RTO List */}
                <Grid item xs={12}>
                  <Card>
                    <CardContent>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          mb: 2,
                        }}
                      >
                        <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                          RTO Orders List
                        </Typography>
                      </Box>
                      <CustomTable
                        columns={columns}
                        rows={meeshoData?.return?.list || []}
                        page={page}
                        rowsPerPage={rowsPerPage}
                        count={meeshoData?.return?.total || 0}
                        Order={order}
                        OrderBy={orderBy}
                        sortData={sortData}
                        handleChangePage={handleChangePage}
                        handleChangeRowsPerPage={handleChangeRowsPerPage}
                        loading={meeshoData?.return?.loading}
                      />
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            )}
          </Box>
        )}
        {tabValue === 2 && (
          <Box>
            {/* Barcode Scanner and Order ID Input Section */}
            <Card sx={{ mb: 3 }}>
              <CardContent>
                <Typography variant="h6" sx={{ mb: 2, fontWeight: "bold" }}>
                  RTO Processing
                </Typography>

                <Grid container spacing={3} alignItems="center">
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      label="Sub Order No"
                      value={orderId}
                      onChange={(e) => setOrderId(e.target.value)}
                      placeholder="Enter Or Scan Sub Order No"
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() => handleSearchOrder()}
                              color="primary"
                              disabled={!orderId.trim()}
                            >
                              <Icon icon="material-symbols:search" />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      onKeyPress={(e) => {
                        if (e.key === "Enter") {
                          handleSearchOrder();
                        }
                      }}
                    />
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Box>
        )}
        {tabValue === 3 && (
          <Box>
            {showOrdersList && (
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Card>
                    <CardContent>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          mb: 2,
                        }}
                      >
                        <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                          Products pending for claims list
                        </Typography>
                      </Box>
                      <CustomTable
                        columns={claimColumns}
                        rows={meeshoData?.return?.list || []}
                        page={page}
                        rowsPerPage={rowsPerPage}
                        count={meeshoData?.return?.total || 0}
                        Order={order}
                        OrderBy={orderBy}
                        sortData={sortData}
                        handleChangePage={handleChangePage}
                        handleChangeRowsPerPage={handleChangeRowsPerPage}
                        loading={meeshoData?.return?.loading}
                      />
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            )}
          </Box>
        )}
      </CardContent>

      <Dialog
        open={openClaimDialog}
        onClose={handleCloseClaimDialog}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{ mb: 0 }}>Claim Details</DialogTitle>
        <DialogContent>
          <Formik
            initialValues={{
              claimStatus: selectedRTO?.claimStatus || "",
              claimApproval: selectedRTO?.claimApproval || "",
              claimNote: "",
            }}
            validationSchema={validationSchema}
            enableReinitialize
            onSubmit={async (data, { setSubmitting }) => {
              setSubmitting(true);
              let newData = {
                subOrderNumber: selectedRTO?.subOrderNumber,
                claimStatus: data?.claimStatus,
                claimApproval: data?.claimApproval,
                claimNote: data?.claimNote,
              };

              if (data?.claimApproval !== "rejected") {
                delete newData?.claimNote;
              }

              const response = await dispatch(
                meeshoOrderReturnClaimStatus(newData)
              ).unwrap();
              if (response?.status === 200) {
                enqueueSnackbar(response?.data?.responseMessage, {
                  variant: "success",
                });
                setSubmitting(false);
                handleCloseClaimDialog();
                getOrdersData();
              } else {
                enqueueSnackbar(response?.data?.responseMessage, {
                  variant: "error",
                });
              }
            }}
          >
            {({
              values,
              errors,
              touched,
              isSubmitting,
              handleChange,
              handleBlur,
              setFieldValue,
            }) => (
              <Form>
                <Grid container spacing={2} sx={{ pt: 0, mt: 0, mb: 3 }}>
                  <Grid item xs={12} md={6}>
                    <Typography variant="h6">Claim Status</Typography>
                    <FormControl
                      fullWidth
                      error={touched.claimStatus && Boolean(errors.claimStatus)}
                    >
                      <InputLabel id="claimStatus-label">
                        Claim Status
                      </InputLabel>
                      <Select
                        name="claimStatus"
                        labelId="claimStatus-label"
                        id="claimStatus"
                        value={values?.claimStatus}
                        label="claimStatus"
                        onChange={handleChange}
                        onBlur={handleBlur}
                      >
                        {["required", "applied"]?.map((val, i) => {
                          return (
                            <MenuItem key={i} value={val}>
                              {val}
                            </MenuItem>
                          );
                        })}
                      </Select>
                      {touched.claimStatus && errors.claimStatus && (
                        <FormHelperText>{errors.claimStatus}</FormHelperText>
                      )}
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Typography variant="h6">Claim Approval</Typography>
                    <FormControl
                      fullWidth
                      error={
                        touched.claimApproval && Boolean(errors.claimApproval)
                      }
                    >
                      <InputLabel id="claimApproval-label">
                        Claim Approval
                      </InputLabel>
                      <Select
                        name="claimApproval"
                        labelId="claimApproval-label"
                        id="claimApproval"
                        value={values.claimApproval}
                        label="claimApproval"
                        onChange={handleChange}
                        onBlur={handleBlur}
                      >
                        {["pending", "approved", "rejected"]?.map((val, i) => {
                          return (
                            <MenuItem key={i} value={val}>
                              {val}
                            </MenuItem>
                          );
                        })}
                      </Select>
                      {touched.claimApproval && errors.claimApproval && (
                        <FormHelperText>{errors.claimApproval}</FormHelperText>
                      )}
                    </FormControl>
                  </Grid>
                  {values.claimApproval === "rejected" ? (
                    <Grid item xs={12} md={12}>
                      <JumboAppTextField
                        fullWidth
                        name="claimNote"
                        label="Claim Note*"
                      />
                    </Grid>
                  ) : (
                    ""
                  )}
                </Grid>

                <Stack
                  spacing={{ xs: 1, sm: 2 }}
                  direction="row"
                  justifyContent="flex-end"
                  alignItems="flex-end"
                  sx={{ width: "100%", pt: { xs: 3, md: 0 } }}
                >
                  <LoadingButton
                    variant="outlined"
                    color="secondary"
                    size="large"
                    onClick={handleCloseClaimDialog}
                    fullWidth={mobileView}
                  >
                    Cancel
                  </LoadingButton>
                  {selectedRTO?.order?.orderFinalStatus !== 2 ? (
                    <LoadingButton
                      type="submit"
                      variant="contained"
                      size="large"
                      loading={isSubmitting}
                      loadingIndicator={<CircularProgress size={20} />}
                      fullWidth={mobileView}
                    >
                      Save
                    </LoadingButton>
                  ) : (
                    ""
                  )}
                </Stack>
              </Form>
            )}
          </Formik>
        </DialogContent>
      </Dialog>

      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>RTO Details - {selectedRTO?.orderNumber}</DialogTitle>
        <DialogContent>
          {selectedRTO && (
            <Grid container spacing={2} sx={{ mt: 1 }}>
              {/* Order Info */}
              <Grid item xs={12}>
                <Typography
                  variant="subtitle1"
                  fontWeight="bold"
                  sx={{ mb: 1 }}
                >
                  Order Info
                </Typography>
                <TextField
                  fullWidth
                  label="Order Number"
                  value={selectedRTO.orderNumber}
                  InputProps={{ readOnly: true }}
                  sx={{ mb: 2 }}
                />
                <TextField
                  fullWidth
                  label="Sub Order Number"
                  value={selectedRTO.subOrderNumber}
                  InputProps={{ readOnly: true }}
                  sx={{ mb: 2 }}
                />
              </Grid>

              {/* Product Info */}
              <Grid item xs={12} md={6}>
                <Typography
                  variant="subtitle1"
                  fontWeight="bold"
                  sx={{ mb: 1 }}
                >
                  Product Info
                </Typography>
                <TextField
                  fullWidth
                  label="SKU"
                  value={selectedRTO.sku}
                  InputProps={{ readOnly: true }}
                  sx={{ mb: 2 }}
                />
                <TextField
                  fullWidth
                  label="Quantity"
                  value={selectedRTO.qty}
                  InputProps={{ readOnly: true }}
                  sx={{ mb: 2 }}
                />
                <TextField
                  fullWidth
                  label="Variation"
                  value={selectedRTO.variation}
                  InputProps={{ readOnly: true }}
                  sx={{ mb: 2 }}
                />
              </Grid>

              {/* Return Info */}
              <Grid item xs={12} md={6}>
                <Typography
                  variant="subtitle1"
                  fontWeight="bold"
                  sx={{ mb: 1 }}
                >
                  Return Info
                </Typography>
                <TextField
                  fullWidth
                  label="Return Type"
                  value={selectedRTO.typeOfReturn}
                  InputProps={{ readOnly: true }}
                  sx={{ mb: 2 }}
                />
                <TextField
                  fullWidth
                  label="Sub Type"
                  value={selectedRTO.subType}
                  InputProps={{ readOnly: true }}
                  sx={{ mb: 2 }}
                />
                <TextField
                  fullWidth
                  label="Return Price Type"
                  value={selectedRTO.returnPriceType}
                  InputProps={{ readOnly: true }}
                  sx={{ mb: 2 }}
                />
                <TextField
                  fullWidth
                  label="Return Reason"
                  value={selectedRTO.returnReason}
                  InputProps={{ readOnly: true }}
                  multiline
                  rows={2}
                  sx={{ mb: 2 }}
                />
                <TextField
                  fullWidth
                  label="Detailed Reason"
                  value={selectedRTO.detailedReturnReason}
                  InputProps={{ readOnly: true }}
                  multiline
                  rows={2}
                  sx={{ mb: 2 }}
                />
              </Grid>

              {/* Logistics Info */}
              <Grid item xs={12} md={6}>
                <Typography
                  variant="subtitle1"
                  fontWeight="bold"
                  sx={{ mb: 1 }}
                >
                  Logistics Info
                </Typography>
                <TextField
                  fullWidth
                  label="AWB Number"
                  value={selectedRTO.awbNumber}
                  InputProps={{ readOnly: true }}
                  sx={{ mb: 2 }}
                />
                <TextField
                  fullWidth
                  label="Courier Partner"
                  value={selectedRTO.courierPartner}
                  InputProps={{ readOnly: true }}
                  sx={{ mb: 2 }}
                />
                <TextField
                  fullWidth
                  label="Tracking Link"
                  value={selectedRTO.trackingLink}
                  InputProps={{
                    readOnly: true,
                    endAdornment: (
                      <Button
                        size="small"
                        onClick={() =>
                          window.open(selectedRTO.trackingLink, "_blank")
                        }
                      >
                        Track
                      </Button>
                    ),
                  }}
                  sx={{ mb: 2 }}
                />
              </Grid>

              {/* Dates */}
              <Grid item xs={12} md={6}>
                <Typography
                  variant="subtitle1"
                  fontWeight="bold"
                  sx={{ mb: 1 }}
                >
                  Timeline
                </Typography>
                <TextField
                  fullWidth
                  label="Dispatch Date"
                  value={
                    selectedRTO.dispatchDate
                      ? new Date(selectedRTO.dispatchDate).toLocaleDateString()
                      : "-"
                  }
                  InputProps={{ readOnly: true }}
                  sx={{ mb: 2 }}
                />
                <TextField
                  fullWidth
                  label="Return Created Date"
                  value={
                    selectedRTO.returnCreatedDate
                      ? new Date(
                          selectedRTO.returnCreatedDate
                        ).toLocaleDateString()
                      : "-"
                  }
                  InputProps={{ readOnly: true }}
                  sx={{ mb: 2 }}
                />
                <TextField
                  fullWidth
                  label="Expected Delivery Date"
                  value={
                    selectedRTO.expectedDeliveryDate
                      ? new Date(
                          selectedRTO.expectedDeliveryDate
                        ).toLocaleDateString()
                      : "-"
                  }
                  InputProps={{ readOnly: true }}
                  sx={{ mb: 2 }}
                />
              </Grid>

              {/* Alerts / Status */}
              <Grid item xs={12}>
                <Alert severity="info">
                  Current Status: <b>{selectedRTO.status}</b>
                </Alert>
                {selectedRTO.attempt !== "NA" && (
                  <Alert severity="warning" sx={{ mt: 1 }}>
                    Attempt: {selectedRTO.attempt}
                  </Alert>
                )}
              </Grid>
            </Grid>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog}>Close</Button>
        </DialogActions>
      </Dialog>

      {/* RTO Status Update Popup */}
      <Dialog
        open={showRTOPopup}
        onClose={handleCloseRTOPopup}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Icon icon="material-symbols:package-2" color="#2874f0" />
            RTO Order Found
          </Box>
        </DialogTitle>
        <DialogContent>
          {foundOrder && (
            <Box>
              <Alert severity="success" sx={{ mb: 2 }}>
                Order ID: <strong>{foundOrder.orderId}</strong> found in RTO
                database
              </Alert>

              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Customer State"
                    value={foundOrder.customerState}
                    InputProps={{ readOnly: true }}
                    sx={{ mb: 2 }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Product"
                    value={foundOrder.productName}
                    InputProps={{ readOnly: true }}
                    multiline
                    rows={2}
                    sx={{ mb: 2 }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="Current Status"
                    value={foundOrder.orderState}
                    InputProps={{ readOnly: true }}
                    sx={{ mb: 2 }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="Amount"
                    value={`₹${foundOrder.discountedPrice}`}
                    InputProps={{ readOnly: true }}
                    sx={{ mb: 2 }}
                  />
                </Grid>
              </Grid>

              <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
                Please select the appropriate action for this RTO:
              </Typography>
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 3, gap: 2 }}>
          <Button onClick={handleCloseRTOPopup} variant="outlined">
            Cancel
          </Button>
          <Button
            onClick={() => handleRTOReceived(false)}
            variant="contained"
            color="error"
            startIcon={<Icon icon="material-symbols:close" />}
          >
            Wrong RTO
          </Button>
          <Button
            onClick={() => handleRTOReceived(true)}
            variant="contained"
            color="success"
            startIcon={<Icon icon="material-symbols:check" />}
          >
            RTO Received
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default MeeshoRTO;
